export const underscoreToTitleCase = underscore => underscore
  .replace(/_/g, ' ')
  .replace(/\b([a-z\u00C0-\u00ff])/g, (_, initial) => initial.toUpperCase());


// WEBPACK FOOTER //
// ./src/utils/strings.js